import { Box, Checkbox, Divider, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useState } from 'react';
import { useRefinementList } from 'react-instantsearch';
import SearchInput from '../../../common/components/SearchInput';
import { insensitiveStringIncludes } from '../../../common/utils/common.utils';
import FilterDisplay, { FilterDisplayMode } from '../../../search/filters/FilterDisplay';

export interface ClassificationTagFilterProps {
  attribute: string;
  label: string;
  mode: FilterDisplayMode;
  getItemLabel: (value: string) => string;
}

export default function ClassificationTagFilter({ attribute, label, mode, getItemLabel }: ClassificationTagFilterProps): React.JSX.Element | null {
  const { items, refine } = useRefinementList({
    attribute,
    limit: 100,
    sortBy: ['count:desc', 'name:asc'],
  });
  const [itemQuery, setItemQuery] = useState('');
  const activeItemCount = items.filter(({ isRefined }) => isRefined).length;
  const visibleItems = items.filter((item) => (
    insensitiveStringIncludes(getItemLabel(item.value), itemQuery)
  ));
  if (!items.length) {
    return null;
  }

  return (
    <>
      {mode === 'ACCORDION' && <Divider />}
      <FilterDisplay
        mode={mode}
        label={label}
        activeItemCount={activeItemCount}
        onClose={() => setItemQuery('')}
        content={(
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
            <SearchInput fullWidth value={itemQuery} onChange={setItemQuery} />
            <List>
              {visibleItems.map((item) => (
                <ListItemButton
                  key={item.value}
                  onClick={() => refine(item.value)}
                >
                  <ListItemText primary={getItemLabel(item.value)} />
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      checked={item.isRefined}
                    />
                  </ListItemIcon>
                </ListItemButton>
              ))}
            </List>
          </Box>
        )}
        name={attribute}
      />
    </>
  );
}
